import Vue from "vue";
import urlExist from "url-exist";

Vue.prototype.$urlExist = urlExist;
